import React, {useContext, useEffect, useState} from "react"
import {injectIntl} from "react-intl";
import Select, {SelectOption} from "@amzn/meridian/select";
import {LidarOverviewContext} from "./context/LidarOverviewContext";
import {
    getAPIGatewayPostRequest,
} from "../../util/Util";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {
    ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT,
    LIDAR_TESTER_ACTIVATION_INTERVAL_MS,
} from "../../util/Constants";
import LidarTesterGridView from "./lidarTester/LidarTesterGridView";
import {getLidarTesterActivationRequest} from "../../util/LidarTesterUtil";
import {getLocalizedMessage} from "../../util/Localization";

const CONTAINER_STYLE = {
    overflow: 'auto'
};

const LidarTesterTool = ({intl}) => {

    const {viewModel, dispatch} = useContext(LidarOverviewContext);
    const [selectedMac, setSelectedMac] = useState(null);

    const device = viewModel.lidarDeviceInformation[selectedMac];

    const activateLidarTester = () => {
        const args = getAPIGatewayPostRequest(getLidarTesterActivationRequest(), ENDPOINT_PUBLISH_COMMAND_TO_THIN_CLIENT);
        getAPIGatewayDataFromParent(args).then(r => console.log("Lidar Tester Activated"));
    }

    useEffect(() => {
        dispatch({type: 'LOAD_VIEW', data: {dispatcher: dispatch}});

        activateLidarTester();
        const lidarActivationInterval = setInterval(() => {
            activateLidarTester();
        }, LIDAR_TESTER_ACTIVATION_INTERVAL_MS)

        return () => {
            clearInterval(lidarActivationInterval)
        }
    }, [])

    return (
        <div style={CONTAINER_STYLE}>
            <Row>
                <Text tag="label" type="b300" color="primary">
                    {getLocalizedMessage({intl, stringId: "lidarTester.select"})}
                </Text>
                <Select
                    value={selectedMac}
                    onChange={setSelectedMac}
                    placeholder={getLocalizedMessage({intl, stringId: "lidarTester.select"})}
                    size="small"
                    width={250}>
                    {Object.values(viewModel.lidarDeviceInformation).map((device) => (
                        <SelectOption key={device.mac} value={device.mac}
                                      label={device.location + " (" + device.mac + ")"}/>
                    ))}
                </Select>
            </Row>
            {<LidarTesterGridView {...{device, selectedMac, intl}}/>}
        </div>
    )
}

export default injectIntl(LidarTesterTool)



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/LidarTesterTool.js